const NoPage = () => {
  return <h1>Error 404: can't find this page</h1>;
};

export default NoPage;
